module.exports = __webpack_public_path__ + "static/media/Spinner-Loading.042fa941.gif";